module.exports = __webpack_public_path__ + "static/img/ban-1.474110a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-1.jpg
// module id = DhA4
// module chunks = 0